module.exports = __webpack_public_path__ + "static/media/moons_escaneo_3D.a6a63c62.png";